/**
 * Detects the authentication method from Clerk external accounts.
 * Maps Clerk OAuth provider identifiers to our standard AuthMethod type.
 */

import type { AuthMethod } from '@saaga/shared/interfaces/gtm.interface'

interface ExternalAccountInput {
  provider: string
}

const PROVIDER_MAP: Record<string, AuthMethod> = {
  google: 'google',
  oauth_google: 'google',
  microsoft: 'microsoft',
  oauth_microsoft: 'microsoft',
  linkedin: 'linkedin',
  oauth_linkedin: 'linkedin',
  linkedin_oidc: 'linkedin',
  oauth_linkedin_oidc: 'linkedin',
}

export const detectAuthMethod = (externalAccountList: ExternalAccountInput[]): AuthMethod => {
  if (externalAccountList.length === 0) return 'email'
  const provider = externalAccountList[0].provider
  return PROVIDER_MAP[provider] ?? 'email'
}
